import {
    ADD_SHORTLIST_MANAGER,
    ADD_SHORTLIST_MANAGER_FAILURE,
    ADD_SHORTLIST_MANAGER_SUCCESS,
    DELETE_INTERVIEW,
    DELETE_INTERVIEW_ERROR, DELETE_INTERVIEW_SUCCESS,
    GET_ALL_INTERVIEWS, GET_ALL_INTERVIEWS_SUCCESSFULL,
    GET_CANDIDATE_SCREENING_DATA, GET_CANDIDATE_SCREENING_DATA_SUCCESSFULL, GET_CANDIDATE_SCREEN_DATA_FAILED,
    GET_INTERVIEWS,
    GET_INTERVIEWS_FAILED,
    GET_INTERVIEWS_SUCCESSFULL,
    GET_SHORTLIST_CANDIDATE_DATA,
    GET_SHORTLIST_CANDIDATE_DATA_FAILED,
    GET_SHORTLIST_CANDIDATE_DATA_SUCCESS,
    GET_SHORTLIST_MANAGERS_LIST,
    GET_SHORTLIST_MANAGERS_LIST_FAILED,
    GET_SHORTLIST_MANAGERS_LIST_SUCCESS,
    MOVE_TO_SHORTLIST,
    MOVE_TO_SHORTLIST_FAILED,
    MOVE_TO_SHORTLIST_SUCCESS,
    RECRUITMENT_CANDIDATE_DETAIL, RECRUITMENT_CANDIDATE_DETAIL_FAILED, RECRUITMENT_CANDIDATE_DETAIL_SUCCESS,
    UPDATE_SCREENED_CANDIDATE_DETAILS,
    UPDATE_SCREENED_CANDIDATE_DETAILS_FAILED,
    UPDATE_SCREENED_CANDIDATE_DETAILS_SUCCESS,
    UPDATE_SHORTLIST_CANDIDATE_DETAILS,
    UPDATE_SHORTLIST_CANDIDATE_DETAILS_FAILED,
    UPDATE_SHORTLIST_CANDIDATE_DETAILS_SUCCESS
} from "./actionTypes"

export const getInterviews = (jobId, candidateId) => {
    return {
        type: GET_INTERVIEWS,
        payload: { jobId, candidateId }
    }
}
export const getInterviewsSuccessfull = (data) => {
    return {
        type: GET_INTERVIEWS_SUCCESSFULL,
        payload: { data }
    }
}

export const getInterviewsFailure = (error) => {
    return {
        type: GET_INTERVIEWS_FAILED,
        payload: { error }
    }

}
export const getAllInterviews = (obj) => {

    return {
        type: GET_ALL_INTERVIEWS,
        payload: { obj }

    }
}
export const getAllInterviewsSuccessfull = (data) => {
    return {
        type: GET_ALL_INTERVIEWS_SUCCESSFULL,
        payload: { data }
    }
}


export const getCandidateScreenData=(jobId,candidateId)=>{
    return {
        type:GET_CANDIDATE_SCREENING_DATA,
        payload:{jobId,candidateId}
    }
}

export const getCandidateScreenDataSuccess=(data)=>{
    return {
        type:GET_CANDIDATE_SCREENING_DATA_SUCCESSFULL,
        payload:{data}
    }
}

export const getCandidateScreenDataFailed=(error)=>{
    return {
        type:GET_CANDIDATE_SCREEN_DATA_FAILED,
        payload:{error}
    }
}

export const updateScreenedCandidateDetails=(data)=>{
    return{
        type:UPDATE_SCREENED_CANDIDATE_DETAILS,
        payload:{data}
    }
}

export const updateScreenedCandidateDetailsSuccess=(message)=>{
    return{
        type:UPDATE_SCREENED_CANDIDATE_DETAILS_SUCCESS,
        payload:{message}
    }
}

export const updateScreenedCandidateDetailsFailed=(error)=>{
    return{
        type:UPDATE_SCREENED_CANDIDATE_DETAILS_FAILED,
        payload:{error}
    }

}

export const getShortlistManagersList=(jobid)=>{
    return{
        type:GET_SHORTLIST_MANAGERS_LIST,
        payload:{jobid}
       
    }
}

export const getShortlistManagerSuccess=(data)=>{
    return{
        type:GET_SHORTLIST_MANAGERS_LIST_SUCCESS,
        payload:{data}
    }
}

export const getShortlistManagerFailed=(error)=>{
    return{
        type:GET_SHORTLIST_MANAGERS_LIST_FAILED,
        payload:{error}
    }
}

export const addShorlistManager=(data)=>{
    return{
        type:ADD_SHORTLIST_MANAGER,
        payload:{data}
    }
}

export const addShorlistManagerSuccess=(message)=>{
    return{
        type:ADD_SHORTLIST_MANAGER_SUCCESS,
        payload:message
    }
}

export const addShorlistManagerFailed=(error)=>{
    return{
        type:ADD_SHORTLIST_MANAGER_FAILURE,
        payload:error
    }
}

export const moveToShortlist=(data)=>{
    return{
        type:MOVE_TO_SHORTLIST,
        payload:{data}
    }
}

export const moveToShortlistSuccess=(message)=>{
    return{
        type:MOVE_TO_SHORTLIST_SUCCESS,
        payload:{message}
    }

}

export const moveToShortlistFailed=(error)=>{
    return{
        type:MOVE_TO_SHORTLIST_FAILED,
        payload:{error}
    }
}

export const getShortlistCandidateData=(jobId,candidateId)=>{
    return{
        type:GET_SHORTLIST_CANDIDATE_DATA,
        payload:{jobId,candidateId}
    }
}

export const getShortlistCandidateDataSuccess=(data)=>{
    return{
        type:GET_SHORTLIST_CANDIDATE_DATA_SUCCESS,
        payload:{data}
    }
}

export const getShortlistCandidateDataFailed=(error)=>{
    return{
        type:GET_SHORTLIST_CANDIDATE_DATA_FAILED,
        payload:{error}
    }

}


export const updateShorlistCandidateDetails=(data)=>{
    return{
        type:UPDATE_SHORTLIST_CANDIDATE_DETAILS,
        payload:{data}
    }
}

export const updateShortlistCandidateDetailsSuccess=(message)=>{
    return{
        type:UPDATE_SHORTLIST_CANDIDATE_DETAILS_SUCCESS,
        payload:{message}
    }
}

export const updateShortlistCandidateDetailsFailed=(error)=>{
    return{
        type:UPDATE_SHORTLIST_CANDIDATE_DETAILS_FAILED,
        payload:{error}
    }

}

export const recruitmentCandidateDetail=(candidateId)=>{
    return{
        type:RECRUITMENT_CANDIDATE_DETAIL,
        payload:{candidateId}
    }
}

export const recruitmentCandidateDetailSuccess=(data)=>{
    return{
        type:RECRUITMENT_CANDIDATE_DETAIL_SUCCESS,
        payload:{data}
    }
}

export const recruitmentCandidateDetailFailed=(error)=>{
    return{
        type:RECRUITMENT_CANDIDATE_DETAIL_FAILED,
        payload:{error}
    }

}






export const deleteInterview=(obj)=>{
    return{
      type:DELETE_INTERVIEW,
      payload:obj
    }
  }
  
  export const deleteInterviewSuccess=(message)=>{
    return{
      type:DELETE_INTERVIEW_SUCCESS,
      payload:message
    }
  
  }
  
  export const deleteInterviewError=(error)=>{
    return{
      type:DELETE_INTERVIEW_ERROR,
      payload:error
    }
  } 